import React from 'react';
import { HomeIcon, ChevronDownIcon, CalendarIcon, UserIcon } from 'lucide-react';
import { mockData } from './data';
export function DashboardHeader() {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-30" data-id="element-123">
      <div className="max-w-[1600px] mx-auto px-4 md:px-6 py-4 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-124">
        <div className="flex items-center gap-4" data-id="element-125">
          <div className="flex items-center text-[#0A1F5C]" data-id="element-126">
            <HomeIcon className="w-8 h-8 mr-2" data-id="element-127" />
            <div className="flex flex-col leading-none" data-id="element-128">
              <span className="font-black text-xl tracking-tight" data-id="element-129">
                MORTGAGE
              </span>
              <span className="font-bold text-sm tracking-[0.2em]" data-id="element-130">DEPOT</span>
            </div>
          </div>
          <div className="h-10 w-px bg-gray-200 hidden md:block" data-id="element-131" />
          <div data-id="element-132">
            <h1 className="text-xl md:text-2xl font-bold text-[#0A1F5C] uppercase tracking-wide leading-tight" data-id="element-133">
              Processor Dashboard
            </h1>
            <p className="text-xs text-[#2563EB] font-semibold tracking-wide uppercase" data-id="element-134">
              Accurate. Timely. Reliable. Every File.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 flex-wrap" data-id="element-135">
          <button type="button" className="flex items-center bg-gray-50 border border-gray-200 rounded-full pl-2 pr-3 py-1.5 hover:bg-gray-100 transition-colors" data-id="element-136">
            <div className="bg-[#0A1F5C] text-white rounded-full p-1.5 mr-3" data-id="element-137">
              <UserIcon className="w-3.5 h-3.5" data-id="element-138" />
            </div>
            <div className="flex flex-col text-left mr-3" data-id="element-139">
              <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider leading-none mb-0.5" data-id="element-140">
                Processor
              </span>
              <span className="text-sm font-semibold text-gray-900 leading-none" data-id="element-141">
                {mockData.user.name}
              </span>
            </div>
            <span className="bg-[#0A1F5C] text-white text-[10px] font-bold px-2 py-0.5 rounded-full mr-2 uppercase tracking-wider" data-id="element-142">
              {mockData.user.role}
            </span>
            <ChevronDownIcon className="w-4 h-4 text-gray-400" data-id="element-143" />
          </button>

          <button type="button" className="flex items-center bg-gray-50 border border-gray-200 rounded-full pl-3 pr-3 py-1.5 hover:bg-gray-100 transition-colors" data-id="element-144">
            <CalendarIcon className="w-4 h-4 text-[#0A1F5C] mr-2" data-id="element-145" />
            <div className="flex flex-col text-left mr-3" data-id="element-146">
              <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider leading-none mb-0.5" data-id="element-147">
                Month
              </span>
              <span className="text-sm font-semibold text-gray-900 leading-none" data-id="element-148">
                {mockData.user.month}
              </span>
            </div>
            <ChevronDownIcon className="w-4 h-4 text-gray-400" data-id="element-149" />
          </button>
        </div>
      </div>
    </header>;
}